import type { FC } from 'react'
import React from 'react'
import { useCallback } from 'react'
import styles from './CurrentLocationButton.module.scss'
import { useDeliveryAddress } from '@/delivery-address/client'
import { mapGoogleAddressToDeliveryAddress } from '@/location/device-current-location/helpers'
import { useDeviceCurrentLocation } from '@/location/device-current-location/use-device-current-location'
import { useLocalisation } from '@/tools/i18n/client'
import { redirectToCityPage } from '@/tools/migration-helpers/execute-action'
import { IconButton } from '@/tools/ui'
import {
  Button,
  ButtonSize,
  ButtonVariants,
  IconBlob,
  IconBlobType,
  IconButtonSize,
  LocationArrowIcon,
  useSnackbar,
} from '@/tools/ui'

export const CurrentLocationButton: FC = () => {
  const { requestLocation, deviceLocation, deviceAddress } = useDeviceCurrentLocation()
  const { showInfo } = useSnackbar()
  const { t } = useLocalisation()
  const { setDeliveryAddress } = useDeliveryAddress()
  const showSnackBar = useCallback(() => {
    showInfo(
      `${t('address-list.location-modal.title')}. ${t('address-list.location-modal.description')}.`,
      { icon: <IconBlob icon={LocationArrowIcon} type={IconBlobType.critical} /> }
    )
  }, [showInfo, t])

  const handleUseCurrentLocation = async () => {
    if (
      deviceLocation.geolocationPermission === 'denied' ||
      deviceLocation.geolocationPermission === 'unsupported'
    ) {
      showSnackBar()
    } else if (
      deviceLocation.geolocationPermission === undefined ||
      deviceLocation.geolocationPermission === 'prompt'
    ) {
      requestLocation()
    } else if (deviceLocation.geolocationPermission === 'granted' && deviceAddress) {
      const newDeliveryAddress = mapGoogleAddressToDeliveryAddress(deviceAddress)
      await setDeliveryAddress(newDeliveryAddress)
      await redirectToCityPage()
    }
  }

  return (
    <div className={styles.currentLocationButton}>
      <IconButton
        aria-labelledby={t('landing.address-container-location')}
        className={styles.mobileButton}
        icon={LocationArrowIcon}
        size={IconButtonSize.small}
        type="button"
        variant="secondary"
        onClick={handleUseCurrentLocation}
      />
      <Button
        block
        className={styles.desktopButton}
        disabled={deviceLocation?.geolocationPermission === 'unsupported'}
        size={ButtonSize.medium}
        type="button"
        variant={ButtonVariants.secondary}
        onClick={handleUseCurrentLocation}
      >
        {t('landing.address-container-location')}
      </Button>
    </div>
  )
}
